export const common = {
  nav: {
    home: 'Home',
    about: 'About',
    solutions: 'Solutions',
    pricing: 'Pricing',
    contact: 'Contact'
  },
  footer: {
    solutions: 'Solutions',
    company: 'Company',
    contact: 'Contact Us',
    allRightsReserved: 'All rights reserved',
    marketAnalysis: 'Market Analysis',
    leadEnablement: 'Lead Enablement',
    businessIntelligence: 'Business Intelligence',
    strategicSupport: 'Strategic Support',
    about: 'About',
    privacyPolicy: 'Privacy Policy',
    termsOfService: 'Terms of Service'
  },
  contact: {
    phone: 'Phone',
    email: 'Email',
    address: 'Address'
  }
};
